
import clipboard from ".././../../assets/icons/clipboard.svg";
import file from ".././../../assets/icons/file_icon.png";
import milestone from ".././../../assets/icons/milestone.svg";
import squarecheck from ".././../../assets/icons/squarecheck.svg";
import pentagon from ".././../../assets/icons/pentagon.png";
import elephant from ".././../../assets/icons/elephant.png";
import horse from ".././../../assets/icons/horse.png";
import rabbit from ".././../../assets/icons/rabbit.png";
import project from ".././../../assets/icons/project.svg";
import circularpen from ".././../../assets/icons/circularpen.svg";
import deleteicon from ".././../../assets/icons/deleteicon.svg";
import editicon from ".././../../assets/icons/editicon.svg";

const icons = {
    clipboard,
    file,
    milestone,
    squarecheck,
    pentagon,
    elephant,
    horse,
    rabbit,
    project,
    circularpen,
    deleteicon,
    editicon
};

export default icons;